import Badge from "@/Components/Badge/Badge";
import Button from "@/Components/Button/Button";
import useLiveDay from "@/shared/atoms/useLiveDay";
import useLiveSource from "@/shared/atoms/useLiveSource";
import useCommon from "@/shared/hooks/useCommon";
import useUserSettingsQuery from "@/shared/queries/user/useUserSettingsQuery";
import { Sources } from "@/shared/utils/enum";
import { asArray } from "@/shared/utils/helpers";
import { useMemo } from "react";
import useLiveOrdersHook from "./useLiveOrdersHook";
import useSourceHook from "@/shared/hooks/useSourceHook";

const LiveSources = () => {
  const [s, setSource] = useLiveSource();
  const t = useCommon();
  const { data, isPending } = useUserSettingsQuery();
  const { liveSources } = useSourceHook();

  const filtered = useMemo(() => {
    return liveSources.filter((source) =>
      source.value.some((val) => asArray(data?.sources)?.includes(val))
    );
  }, [data, liveSources]);
  return (
    <div className="flex flex-1 gap-2.5 overflow-x-auto py-8 overscroll-x-auto">
      <Button
        isDisabled={s === null}
        onClick={() => setSource(null)}
        size="small"
      >
        <span>{t("all")}</span>
      </Button>
      {!isPending &&
        filtered.map((source) => (
          <LiveSource
            bg={source.bg}
            isDisabled={
              s === null
                ? false
                : s?.some((val) => asArray(source.value)?.includes(val))
            }
            onClick={() => setSource(source.value)}
            key={source.value[0]}
            value={source.value}
            label={t(source.translationKey)}
          />
        ))}
    </div>
  );
};

export const LiveSource = ({
  value,
  label,
  isDisabled = false,
  onClick,
  bg = undefined,
}: {
  value: Sources[];
  label: string;
  isDisabled?: boolean;
  onClick?: () => void;
  bg?: string;
}) => {
  const [day] = useLiveDay();
  const orders = useLiveOrdersHook();
  const count =
    orders?.[day]?.filter((order) =>
      value.includes(Sources.QR)
        ? order.order_information.table_number !== undefined
        : value.includes(Sources.POS)
          ? order.order_information.table_number === undefined &&
            value.includes(order.order_information.source)
          : value.includes(order.order_information.source)
    ).length || 0;

  return (
    <div className="relative">
      <Button bg={bg} onClick={onClick} isDisabled={isDisabled} size="small">
        <span className="whitespace-nowrap">{label}</span>
      </Button>
      {count > 0 && (
        <div className="absolute -right-4 -top-8 z-[2]">
          <Badge animation={""}>
            <div>{count}</div>
          </Badge>
        </div>
      )}
    </div>
  );
};

export default LiveSources;
